
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { Vue, Options } from "vue-class-component";

@Options({
  watch: {
    "$route.fullPath": {
      handler() {
        this.getActiveTabRect();
      },
      immediate: true,
    },
    loading: {
      handler() {
        this.getActiveTabRect();
      },
      immediate: true,
    },
  },
})
class TabRiwayatLastMile extends Vue {
  get tabs() {
    return [
      {
        name: this.$t("dashboard.hanging.historyHangingTab"),
        path: "/dashboard/history-hanging-lastmile",
        refName: "historyHangingLastmile",
        permission: true,
      },
      {
        name: this.$t("dashboard.hanging.historyFollowUpTab"),
        path: "/dashboard/history-follow-up-lastmile",
        refName: "historyFollowUpLastmile",
        permission: true,
      },
    ];
  }

  tabRect = new DOMRect();
  resizeObserver: any = null;

  get loading() {
    return MainAppController.loadingModal;
  }

  async mounted() {
    await this.$nextTick();
    this.getActiveTabRect();
  }

  unmounted() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  async getActiveTabRect() {
    await this.$nextTick();
    const $tabElementRef = this.$refs[
      this.tabs.find((tab) => tab.path === this.$route.fullPath)
        ?.refName as keyof TabRiwayatLastMile
    ] as any;
    if (!$tabElementRef) return new DOMRect();
    const $tabElement = $tabElementRef.$el as HTMLElement;
    this.tabRect = $tabElement.getBoundingClientRect();
  }

  get isSidebarAndBreadcrumbV2() {
    return MainAppController.isSidebarAndBreadcrumbV2;
  }
}
export default TabRiwayatLastMile;
